<template>
    <DsDialog
        v-model:open="isOpen"
        primaryLabel="Close"
        size="sm"
        title="Street view"
        @clickPrimary="isOpen = false"
    >
        <img
            :alt="address"
            class="mx-auto mb-4"
            :src="streetViewUrl"
        />
        <p class="mb-4 text-content-lg text-content-primary">{{ address }}</p>
    </DsDialog>
</template>

<script setup lang="ts">
import DsDialog from '@/components/design-system/DsDialog.vue';

defineProps<{
    address: string;
    streetViewUrl: string;
}>();

const isOpen = defineModel<boolean>('open');
</script>
